// Web build stub for the Live Translation session hook. The real
// implementation imports `react-native-webrtc`, which calls
// `requireNativeComponent` at module load — that symbol doesn't exist in
// React Native Web, so importing it crashes the entire bundle (the root
// `LiveTranslationProvider` mounts this hook unconditionally).
//
// Live Translation is a phone-only feature (microphone + native WebRTC peer
// connection to OpenAI Realtime). On web we return an inert handle so the
// provider can render, the button/pill stay hidden via `isActive === false`,
// and `start()` surfaces a clear error instead of a blank screen if anything
// does invoke it.
//
// Metro resolves `.web.ts` ahead of `.ts` for the `web` platform, so the
// native build is unaffected.
import { useState } from "react";

import type { ModalStatus, OpenSessionInput, TranscriptTurn } from "./types";

interface SessionHandle {
    status: ModalStatus;
    sessionId: number | null;
    targetLanguage: string | null;
    turns: TranscriptTurn[];
    durationMs: number;
    errorMessage: string | null;
    start: (input: OpenSessionInput & { targetLanguage: string }) => Promise<void>;
    stop: () => Promise<void>;
    reset: () => void;
}

export function useLiveTranslationSession(): SessionHandle {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [status, setStatus] = useState<ModalStatus>("idle");

    return {
        status,
        sessionId: null,
        targetLanguage: null,
        turns: [],
        durationMs: 0,
        errorMessage,
        start: async () => {
            setStatus("error");
            setErrorMessage("Live Translation is only available in the mobile app.");
        },
        stop: async () => {
            setStatus("idle");
            setErrorMessage(null);
        },
        reset: () => {
            setStatus("idle");
            setErrorMessage(null);
        }
    };
}
